/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/fade-element/fade-element.js":
/*!*********************************************!*\
  !*** ./src/js/fade-element/fade-element.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (/* binding */ FadeElement)\n/* harmony export */ });\nclass FadeElement extends HTMLElement {\n  constructor() {\n    super();\n    this.logoTypeToDisplay = this.dataset.device;\n    /* this.isMobileSafari = this.detectIsMobile();*/\n    this.mainImageWrapper = document.querySelector(`#shopify-section-${this.dataset.sectionId} [data-main-img-wrapper]`);\n  }\n  connectedCallback() {\n    let touchstartX = 0;\n    let touchstartY = 0;\n    let touchendX = 0;\n    let touchendY = 0;\n    window.addEventListener('scroll', event => {\n      let scrollPos = 0;\n      if (document.body.getBoundingClientRect().top > scrollPos) this.changeLogoOpacity('up');else this.changeLogoOpacity('down');\n      scrollPos = document.body.getBoundingClientRect().top;\n    });\n    this.addEventListener('touchstart', event => {\n      touchstartX = event.changedTouches[0].screenX;\n      touchstartY = event.changedTouches[0].screenY;\n    }, false);\n    this.addEventListener('touchend', event => {\n      touchendX = event.changedTouches[0].screenX;\n      touchendY = event.changedTouches[0].screenY;\n      handleGesture(event);\n    }, false);\n    const handleGesture = event => {\n      if (touchendX < touchstartX) this.changeLogoOpacity('up');else if (touchendX > touchstartX) this.changeLogoOpacity('down');\n    };\n  }\n  changeLogoOpacity(scrollDirection) {\n    const fadeCoefficient = window.innerWidth >= 1024 ? 2.4 : 7;\n    let logoScrolledTo = window.scrollY / window.innerHeight,\n      bottomOfImageWrapper = this.mainImageWrapper.offsetHeight / window.innerHeight / fadeCoefficient,\n      opacityPercent;\n    switch (scrollDirection) {\n      case 'up':\n        opacityPercent = logoScrolledTo / bottomOfImageWrapper;\n        this.style.opacity = opacityPercent <= 0 ? '1' : opacityPercent;\n        break;\n      case 'down':\n        opacityPercent = 1 - logoScrolledTo / bottomOfImageWrapper;\n        this.style.opacity = opacityPercent.toString();\n        break;\n    }\n  }\n  detectIsMobile() {\n    if (window.innerWidth < 1024 && this.logoTypeToDisplay === 'mobile') {\n      this.setLogoStyleOnMobile();\n      return true;\n    }\n    return false;\n  }\n  setLogoStyleOnMobile() {\n    const logoElement = this.querySelector('.t7c-hero__lg-logo-wrapper > *');\n    this.style.height = '100%';\n    logoElement.style.position = 'absolute';\n  }\n}\n\n//# sourceURL=webpack://my-webpack-project/./src/js/fade-element/fade-element.js?");

/***/ }),

/***/ "./src/js/fade-element/index.js":
/*!**************************************!*\
  !*** ./src/js/fade-element/index.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _fade_element_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./fade-element.js */ \"./src/js/fade-element/fade-element.js\");\n\nif (!customElements.get('fade-element')) {\n  customElements.define('fade-element', _fade_element_js__WEBPACK_IMPORTED_MODULE_0__[\"default\"]);\n}\n\n//# sourceURL=webpack://my-webpack-project/./src/js/fade-element/index.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/js/fade-element/index.js");
/******/ 	
/******/ })()
;